import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ContactUsPageComponent } from '../component/page/contact-us-page/contact-us-page.component';
import { OfflineAirlinePageComponent } from '../component/page/group/api-docs/offline-airline-page/offline-airline-page.component';
import { IagBookingPortalsPageComponent } from '../component/page/group/iag-portal/iag-booking-portals-page/iag-booking-portals-page.component';
import { NdcRegistrationManualPageComponent } from '../component/page/group/iag-portal/ndc-registration-manual-page/ndc-registration-manual-page.component';
import { KnownIssuesJiraContentPageComponent } from '../component/page/group/known-issues/known-issues-jira-content-page/known-issues-jira-content-page.component';
import { KnownIssuesPageComponent } from '../component/page/known-issues-page/known-issues-page.component';
import { OperationalAssurancesPageComponent } from '../component/page/operational-assurances-page/operational-assurances-page.component';
import { ServiceStatusPageComponent } from '../component/page/service-status-page/service-status-page.component';
import { SupportPageComponent } from '../component/page/support-page/support-page.component';
import { AuthGuardService } from '../service/auth-guard.service';

const routes: Routes = [
  { path: 'support', component: SupportPageComponent },
  { path: 'register/ndc-registration/registration-manual', component: NdcRegistrationManualPageComponent },
  // { path: 'service/service-status', component: ServiceStatusPageComponent, canActivate: [AuthGuardService] },
  { path: 'service/service-status', component: ServiceStatusPageComponent },
  { path: 'support/ndc-technical-and-operational-support', component: SupportPageComponent },
  { path: 'support/iag-booking-portals-support', component: IagBookingPortalsPageComponent },
  { path: 'operational-assurances', component: OperationalAssurancesPageComponent },
  { path: 'operational-assurances/:pageTitle', component: OperationalAssurancesPageComponent },
  //{ path: 'known-issues/:pageTitle', component: KnownIssuesPageComponent },
  { path: 'known-issues/:pageTitle', component: KnownIssuesJiraContentPageComponent },
  { path: 'contact-us', component: ContactUsPageComponent },
  { path: 'support/offline-airline-profile', component: OfflineAirlinePageComponent, canActivate: [AuthGuardService] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppSupportRoutingModule {}
